import React, { useEffect, useState } from "react";
import Accordion from "./common/Accordion";
import InputFieldControl from "./common/InputFieldControl";
import { storeLead } from "./actions/StoreLeadAction";
import toast from "react-hot-toast";
import { hasPermission } from "../../../../utils/utils";

const CustomerDetailsForm = ({
  customerDetails,
  editPermissions,
  refreshCustomerDetails = () => { },
}) => {

  const [ConfirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    customer_status: "",
    meeting_cadence: "",
    customer_health: "",
    customer_overview: "",
    lead_source: "",
    email: "",
  });

  useEffect(() => {
    if (customerDetails) {
      fetchFromData();
    }
  }, [customerDetails]);

  const fetchFromData = () => {
    setFormData({
      customer_status: customerDetails.customer_status || "",
      meeting_cadence: customerDetails.meeting_cadence || "",
      customer_health: customerDetails.customer_health || "",
      customer_overview: customerDetails.customer_overview || "",
      lead_source: customerDetails.lead_source || "",
      email: customerDetails.email || "",
    });
  };

  const handleInputChange = (valueFor, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [valueFor]: value,
    }));
  };

  const onEditClick = () => {
    setIsEditing(true);
  };

  const handleContactInfoSave = async () => {
    setConfirmationModalOpen(false);
    setIsLoading(true);

    if (!handleValidation()) {
      setIsLoading(false);
      return;
    }

    const response = await storeLead(formData);

    if (response.success) {
      toast.success("Lead Updated successfully!");
      await refreshCustomerDetails();
    } else {
      toast.error(
        "An error occurred while processing your request. Please try again!"
      );
    }

    setIsEditing(false);
    setIsLoading(false);
  };

  const handleCancelEdit = () => {
    fetchFromData();
    setIsEditing(false);
  };

  const handleValidation = () => {
    setErrors({});

    const errors = {};
    let isValid = true;

    if (!formData.customer_status || formData.customer_status.trim() === "") {
      errors.customer_status = "Customer Status is required";
      isValid = false;
    }

     if (!formData.meeting_cadence || formData.meeting_cadence.trim() === "") {
      errors.meeting_cadence = "Meeting Cadence is required";
      isValid = false;
    }

     if (!formData.customer_health || formData.customer_health.trim() === "") {
      errors.customer_health = "Customer Health is required";
      isValid = false;
    }
    setErrors(errors);
    return isValid;
  };

  const ActionButton = () => {
    if (isLoading) {
      return (
        <button className="editprimary-btn editsecondry-btn" disabled>
          Loading...
        </button>
      );
    }

    return (
      <React.Fragment>
        <button
          className="editprimary-btn editsecondry-btn"
          onClick={(e) => {
            e.stopPropagation();
            if (isEditing) {
              // onSaveClick();
              handleContactInfoSave();
            } else {
              onEditClick();
            }
          }}
        >
          {!isEditing && (
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <g clip-path="url(#clip0_501_8376)">
                  <path
                    d="M8.5 1.5C8.63132 1.36868 8.78722 1.26451 8.9588 1.19344C9.13038 1.12236 9.31428 1.08578 9.5 1.08578C9.68572 1.08578 9.86962 1.12236 10.0412 1.19344C10.2128 1.26451 10.3687 1.36868 10.5 1.5C10.6313 1.63132 10.7355 1.78722 10.8066 1.9588C10.8776 2.13038 10.9142 2.31428 10.9142 2.5C10.9142 2.68572 10.8776 2.86961 10.8066 3.04119C10.7355 3.21277 10.6313 3.36868 10.5 3.5L3.75 10.25L1 11L1.75 8.25L8.5 1.5Z"
                    stroke="#006EFA"
                    stroke-width="1.33"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_501_8376">
                    <rect width="12" height="12" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
            </span>
          )}
          {isEditing ? "Save" : "Edit"}
        </button>
        {isEditing && (
          <button
            className="editprimary-btn editsecondry-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleCancelEdit();
            }}
          >
            {"Cancel"}
          </button>
        )}
      </React.Fragment>
    );
  };

  return (
    <Accordion
      header="Customer Details"
      targetID="customerDetailsForm"
      actionButton={editPermissions && <ActionButton />}
      overrideOpenState={isEditing ? true : null}
    >
      <div className="form-customer-details">
        <div className="customer-info">
          <InputFieldControl
            fieldName="customer_status"
            label="Customer Status"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            required={true}
            error={errors.customer_status}
            data={
              [
              { value: "Live", id: "Live" },
              { value: "Onboarding", id: "Onboarding" }
              ]
            }
          />
          <InputFieldControl
            fieldName="meeting_cadence"
            label="Meeting Cadence"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            required={true}
            error={errors.meeting_cadence}
            data={[
              { value: "Weekly", id: "Weekly" },
              { value: "Bi-Weekly", id: "Bi-Weekly" },
              { value: "Monthly", id: "Monthly" },
            ]}
          />
          <InputFieldControl
            fieldName="customer_health"
            label="Customer Health"
            type={"select"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            error={errors.customer_health}
            required={true}
            data={[
              { value: "Red", id: "Red" },
              { value: "Orange", id: "Orange" },
              { value: "Green", id: "Green" },
            ]}
          />
          <InputFieldControl
            fieldName="customer_overview"
            label="Customer Overview"
            type={"textarea"}
            isEditing={isEditing}
            formData={formData}
            handleInputChange={handleInputChange}
            isLoading={isLoading}
            required={false}
            error={errors.customer_overview}
          />
          
        </div>
      </div>

    </Accordion>
  );
};

export default CustomerDetailsForm;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/CustomerDetailsForm.js